import { useSelector } from "react-redux";
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";
import { Icon } from "../../../components/base";
import { NoDataCard } from "../../../components/parts";
import { LabelBarChart } from "../../../components/charts";
import { currencyFormatter, nKilowattFormatter } from "../../../services";
import electricityEfficiencyImg from "../../../assets/images/icons/electricity-efficiency.svg";

const useStyles = makeStyles(() => ({
  chartBox: {
    height: 270,
    borderRadius: 8,
    marginTop: 20,
  },
  title: {
    padding: "10px 0 0 20px",
  },
}));

export const ElectricityEfficiencyPart = ({
  electricityCostsPerSquareChartData,
  electricityConsumptionPerSquareChartData,
  bars,
}) => {
  const { user } = useSelector((state) => state.auth);
  const classes = useStyles();
  return (
    <Box style={{ backgroundColor: COLORS.darks[0][3], borderRadius: 8, marginBottom: 30 }}>
      <Grid container>
        <Grid item xs={4} container justifyContent="center" alignItems="center" direction="column">
          <Icon src={electricityEfficiencyImg} />
          <Typography variant="h2" style={{ fontWeight: 500, marginTop: 20 }}>
            Electricity Efficiency
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h4" className={classes.title}>
            Total electricity costs/{user.unit_system}
          </Typography>
          <Box className={classes.chartBox}>
            {electricityCostsPerSquareChartData.length ? (
              <LabelBarChart
                top={50}
                left={5}
                right={35}
                height={270}
                chartData={electricityCostsPerSquareChartData}
                bars={bars}
                barSize={50}
                yTickFormatter={currencyFormatter}
              />
            ) : (
              <NoDataCard withShaDowBox={false} gridStyle={{ height: 160 }} />
            )}
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h4" className={classes.title}>
            Total est. electricity Consum./{user.unit_system}
          </Typography>
          <Box className={classes.chartBox}>
            {electricityConsumptionPerSquareChartData.length ? (
              <LabelBarChart
                top={50}
                left={5}
                right={35}
                height={270}
                chartData={electricityConsumptionPerSquareChartData}
                bars={bars}
                barSize={50}
                yTickFormatter={nKilowattFormatter}
              />
            ) : (
              <NoDataCard withShaDowBox={false} gridStyle={{ height: 160 }} />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
